import React from 'react';
import VBLeaflet from "@virkesborsen/vb-js-commons/lib/components/new/vbLeaflet";
import { LayerSelector, ZoomAndLayerButtons} from '../../../components/mapComponents/MapComponents';

class NHLeafletChange extends React.Component {
    constructor(props) {
        super(props);

        this.map = React.createRef();

        this.state={
            mobile_map_visible:false,
            layers: {},
            imageOverlay: null,
            mapTools:false,
            refresh: false,
            geojsonItems:null
        }
        this.allGeojsonLayers = L.featureGroup([])
    }

    componentDidMount(){
        if(this.props.geojson){
            const timeout = setTimeout(() => {
            if(this.map.current.state.map){
                let nhProp = L.featureGroup([])
                
                let group = L.geoJSON(this.props.geojson, { color: "#FFFFFF",fillColor:"transparent"})
                 
                nhProp.addLayer(group);
                this.map.current.setLayers(nhProp);
                nhProp.addTo(this.map.current.state.map)
                //this.map.current.state.map.fitBounds(nhProp.getBounds())
                
                clearTimeout(timeout);
            }
        }, 50)
        }

        if(this.props.sections){
            const t2 = setTimeout(() => {
            if(this.map.current.state.map){
                this.props.sections.map((sect) => {
                    this.addGeojsonToMap(sect.geom, null, sect.geom_color ? sect.geom_color : "#03A086", false)
                });
                
                clearTimeout(t2);
            }
        }, 50)
        }
    }
    removeLayer(key){

        this.map.current.state.map.removeLayer(this.state.layers[key])
        if(this.state.imageOverlay){
            this.map.current.state.map.removeLayer(this.state.imageOverlay)
        }
    }

    addImageOverlayToMap(imageOverlay){
        if(this.state.imageOverlay){
            this.map.current.state.map.removeLayer(this.state.imageOverlay)
        }

        imageOverlay.addTo(this.map.current.state.map);
        this.map.current.state.map.fitBounds(imageOverlay.getBounds());

        this.setState({
            imageOverlay: imageOverlay
        })
    }

    addGeojsonToMap(geojson, key=null, color="#f6f6f6", addToDrawn=true) {
        let style = { color: color ? color : "#f6f6f6",fillColor: "transparent"}
        let geojsonLayer=L.geoJSON(geojson, style)
             
        if(addToDrawn){
            geojsonLayer.eachLayer((layer)=>{
                this.state.layers[key] = layer
                this.map.current.state.map.fitBounds(geojsonLayer.getBounds())
            })               
        }           
    
        this.allGeojsonLayers.addLayer(geojsonLayer)
        this.map.current.setLayers(this.allGeojsonLayers)
        this.allGeojsonLayers.addTo(this.map.current.state.map)
        this.setState({layers: this.state.layers});

        if(this.allGeojsonLayers.getBounds().isValid() && !addToDrawn){
            this.map.current.state.map.fitBounds(this.allGeojsonLayers.getBounds())
        }
       
    }

    render() {
        return (
            <>
                <VBLeaflet ref={this.map} id='nhleaflet_change' baseMap='Mapbox Satelite' />
                <ZoomAndLayerButtons mapRef = {this.map} mapTools={this.state.mapTools} setMapTools = {(val)=>{this.setState({mapTools:val})}} />
                {this.state.mapTools && <LayerSelector mapRef = {this.map} mapTools={this.state.mapTools} setMapTools = {(val)=>{this.setState({mapTools:val})}} setRefresh={(val)=>this.setState({refresh:val})}/>}
            </>
        )
    }
}
export default NHLeafletChange;